import { Box, Stack, Typography } from '@mui/material'

const ModuleHeader = ({ title, subtitle, Icon, actions, color }) => {
    const accent = color || '#2563eb'
    return (
        <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems={{ xs: 'flex-start', md: 'center' }}
            justifyContent="space-between"
            sx={{ px: { xs: 0.5, sm: 1 }, pb: { xs: 1.25, sm: 2 }, gap: { xs: 1, sm: 1.5 } }}
        >
            <Stack spacing={0.75} direction="row" alignItems="center">
                {Icon ? (
                    <Box sx={{
                        width: { xs: 44, sm: 50 }, height: { xs: 44, sm: 50 }, borderRadius: 3,
                        background: `linear-gradient(135deg, ${accent}cc, ${accent})`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        boxShadow: `0 6px 18px ${accent}55`, flexShrink: 0
                    }}>
                        <Icon sx={{ color: '#fff', fontSize: { xs: 22, sm: 26 } }} />
                    </Box>
                ) : null}
                <Stack spacing={0.25} sx={{ ml: Icon ? 1 : 0 }}>
                    <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: -0.5, fontSize: { xs: '1.28rem', sm: '1.5rem' }, lineHeight: 1.2 }}>{title}</Typography>
                    {subtitle ? (
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>{subtitle}</Typography>
                    ) : null}
                </Stack>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ width: { xs: '100%', md: 'auto' } }}>
                {actions}
            </Stack>
        </Stack>
    )
}

export default ModuleHeader
